import React from 'react';
import { IconProps } from '../../Interfaces/Props';

const IconPublish = (props: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.size ?? '18'}
      height={props.size ?? '18'}
      className={props.className}
      viewBox="0 0 32 32"
    >
      <path
        fill="currentColor"
        d="M18 26h8.172l-2.586 2.586L25 30l5-5l-5-5l-1.414 1.414L26.172 24H18zm-8-5h5v2h-5zm0-5h10v2H10z"
      />
      <path
        fill="currentColor"
        d="m24.7 9.3l-7-7c-.2-.2-.4-.3-.7-.3H7c-1.1 0-2 .9-2 2v24c0 1.103.898 2 2 2h8v-2H7V4h8v6c0 1.1.9 2 2 2h6v6h2v-8c0-.3-.1-.5-.3-.7M17 10V4.4l5.6 5.6z"
      />
    </svg>
  );
};

export default IconPublish;
